/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectCategoryCommand } from '../../models/delete-project-category-command';
import { DeleteProjectCategoryCommandResult } from '../../models/delete-project-category-command-result';

export interface ApiProjectCategoriesDeleteProjectCategoryDelete$Params {
  
    /**
     * The details of the Project Category to delete.
     */
    body?: DeleteProjectCategoryCommand
}

export function apiProjectCategoriesDeleteProjectCategoryDelete(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesDeleteProjectCategoryDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesDeleteProjectCategoryDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectCategoryCommandResult>;
    })
  );
}

apiProjectCategoriesDeleteProjectCategoryDelete.PATH = '/api/ProjectCategories/DeleteProjectCategory';
